import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Chip,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { DialogDefaultV2 } from '../../../../components/v2';
import { STATUS_OPTIONS_DESCRIPTION } from '../../../../constants/status';

const NsirMapaDetailDialog = ({ open, nsir, onClose }) => {
  if (!nsir) return null;

  const statusLabel = STATUS_OPTIONS_DESCRIPTION[nsir.status] || nsir.status;

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onClose}
      handlerConfirm={onClose}
      title={`NSIR ${nsir.codigo}`}
      cancelMessage="Fechar"
      maxWidth="sm"
      fullWidth
      readOnly
      headerAction={[
        {
          title: 'Abrir NSIR',
          onClick: () => window.open(`/nsir/${nsir.id}`, '_blank', 'noopener,noreferrer'),
          show: true,
        },
      ]}
    >
      <Stack spacing={2}>
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          <Chip label={statusLabel} size="small" color="primary" variant="outlined" />
          {nsir.anomalia && (
            <Chip
              icon={<ReportProblemIcon />}
              label="Anomalia detectada"
              size="small"
              color="error"
            />
          )}
        </Stack>

        <Grid container spacing={1}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Typography variant="caption" color="text.secondary" display="block">
              Serviço
            </Typography>
            <Typography variant="body2">
              {[nsir.tipoServico, nsir.subtipo].filter(Boolean).join(' · ') || '—'}
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Typography variant="caption" color="text.secondary" display="block">
              Equipamento
            </Typography>
            <Typography variant="body2">{nsir.equipamento || '—'}</Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Typography variant="caption" color="text.secondary" display="block">
              Latitude
            </Typography>
            <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
              {nsir.lat ?? nsir.latitude ?? '—'}
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Typography variant="caption" color="text.secondary" display="block">
              Longitude
            </Typography>
            <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
              {nsir.lng ?? nsir.longitude ?? '—'}
            </Typography>
          </Grid>
        </Grid>

        <Box
          sx={{
            p: 1.5,
            borderRadius: 1,
            bgcolor: 'action.hover',
            border: 1,
            borderColor: 'divider',
          }}
        >
          <Typography variant="caption" color="text.secondary">
            Clique em &quot;Abrir NSIR&quot; para ver fotos, croqui e histórico completo da inspeção.
          </Typography>
        </Box>
      </Stack>
    </DialogDefaultV2>
  );
};

NsirMapaDetailDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  nsir: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};

NsirMapaDetailDialog.defaultProps = {
  nsir: null,
};

export default NsirMapaDetailDialog;
